import { Typography } from "@mui/material";
import { Box, styled } from "@mui/system";


export const FormTitle = styled(Box)({
  fontWeight: 'bold',
  fontSize: '18px',
  marginBottom: '10px',
  marginLeft: '25px',
});

export const FormContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  padding: '0 25px',
  justifyContent: 'center',
  marginBottom: '10px',
  flexDirection: 'column',
  alignItems: 'center'
});

// Fixed height scroll area for the popup body to prevent overall dialog height changes
export const FixedHeightBody = styled(Box)(({ theme }) => ({
  height: '700px', // adjust as needed
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxSizing: 'border-box'
}));

export const ScrollRegion = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingBottom: theme.spacing(1),
}));

export const FieldContainer = styled(Box)({
  width: '800px',
  margin: '5px 25px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  "& .MuiFormLabel-root": {
    marginBottom: '9px',
  },
  "& .MuiInputBase-root": {
    minWidth: '100%',
    minHeight: '30px',
    border: '1px solid #b2b9dc',
    borderRadius: '4px',
    "& input": {
      padding: '0px 10px',
    }
  },
  "& .MuiRadio-root" :{
    padding:'0 9px'
  }
});

export const ButtonsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
  padding: '12px 25px 8px',
  //borderBottom: '1px solid #e5e7eb',
  background: '#fff',
  position: 'sticky',
  top: 0,
  zIndex: 2,
  "& .MuiButtonBase-root": {
    height: '28px',
    fontSize: '12px',
    padding: '4px 14px'
  },
});

export const TextAreaContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  borderBottom: '0',
  justifyContent: 'space-between',
  margin: '15px 25px',
  "& .MuiInputBase-root": {
    background: '#f2f4ff',
    minWidth: '100%',
    minHeight: '200px',
  },
  "& .MuiFormLabel-root": {
    minHeight: '50px',
    textWrap: 'wrap',
  },
  "& textarea": {
    minWidth: '100%',
    minHeight: '30px',
    border: '1px solid #b2b9dc',
    borderRadius: '4px',
    resize: 'none',
    padding: '10px',
  }
});

export const SectionContainer = styled(Box)({
    borderRadius: '5px',
    marginBottom: '20px',
    display:'grid',   
    gridTemplateColumns: '1fr 1fr'
});

export const SectionTitle = styled(Box)({
    fontSize: '15px',
    marginBottom: '10px',
    color: '#5c088c',
    textTransform: 'uppercase',
    fontWeight: 'bold'
})
export const ErrorText = styled(Typography)({
  color: 'red',
  width: '375px',
  marginBottom:'10px'
})
